import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Dedicated instance for the consumer Health Vault. No refresh interceptor, so a 401
// here never redirects into the staff app — the vault has its own auth (hv_token cookie).
const hapi = axios.create({ baseURL: API, withCredentials: true });

export function hError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default hapi;
